import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=137c3496&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=137c3496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c3496",
  null
  
)

export default component.exports